import SET_PROJECTS from './constants';


const defaultState = [];

const projects = (state = defaultState, action) => {
    switch (action.type) {
        case SET_PROJECTS:
            return action.projects;

        default:
            return state;
    }
};

export default projects;



// WEBPACK FOOTER //
// ./src/containers/common/projects/reducer.js